import * as tslib_1 from "tslib";
import { ElementRef, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { UsersApi } from '@api/users/users.api';
import { MaintenancesApi } from '@core/api/maintenances/maintenances.api';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { SocketService } from '@core/services/socket.service';
import { delay } from '@core/utils/delay';
import { NotificationTypeEnum } from '@interfaces';
import { kebabCase, map } from 'lodash';
import { Subject } from 'rxjs';
import { debounceTime, filter, takeUntil } from 'rxjs/operators';
var notBlank = function (control) {
    if (control.value.trim() === '') {
        return {
            empty: true
        };
    }
    return null;
};
var ɵ0 = notBlank;
var TabCommentsComponent = /** @class */ (function () {
    function TabCommentsComponent(data, authenticationService, customMessageService, maintenancesApi, socketService, formBuilder, usersApi) {
        this.data = data;
        this.authenticationService = authenticationService;
        this.customMessageService = customMessageService;
        this.maintenancesApi = maintenancesApi;
        this.socketService = socketService;
        this.formBuilder = formBuilder;
        this.usersApi = usersApi;
        this.comments = [];
        this.isLoading = false;
        this.offset = 0;
        this.limit = 10;
        this.selected = 'internal';
        this.isLoadingMore = false;
        this.messageFormControl = new FormControl('', [Validators.required, Validators.maxLength(1000), notBlank]);
        this.subscriptions = new Subject();
        this.maintenance = this.data.maintenance;
    }
    TabCommentsComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.next();
        this.subscriptions.complete();
    };
    TabCommentsComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var account;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.commentForm = this.formBuilder.group({
                            message: this.messageFormControl,
                            type: ['internal', Validators.required],
                        });
                        this.currentUser = this.authenticationService.user;
                        return [4 /*yield*/, this.usersApi.me()];
                    case 1:
                        account = (_a.sent()).account;
                        this.account = account;
                        this.accountName = account.name;
                        this.fieldAccountName = (this.maintenance.company && this.maintenance.company.name) || '';
                        this.getComments();
                        this.scrollToBottom();
                        this.socketService.lastNotificationObs
                            .pipe(takeUntil(this.subscriptions), filter(function (message) { return message.type === kebabCase(NotificationTypeEnum.maintenanceCommented); }), filter(function (message) { return message.maintenance.id === _this.maintenance.id; }), filter(function (_a) {
                            var comment = _a.comment;
                            return !map(_this.comments, 'id').includes(comment.id);
                        }))
                            .subscribe(function (_a) {
                            var comment = _a.comment;
                            _this.comments.push(comment);
                            _this.scrollToBottom();
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    TabCommentsComponent.prototype.getComments = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isLoading = true;
                        return [4 /*yield*/, this.maintenancesApi
                                .searchMaintenanceComment({ maintenanceId: this.maintenance.id, limit: this.limit, offset: this.offset })
                                .pipe(debounceTime(500))
                                .toPromise()
                                .then(function (comments) {
                                var _a;
                                if (!comments.length && _this.isLoadingMore) {
                                    _this.customMessageService.custom('MAINTENANCES.TABS.COMMENTS.NO_MORE_COMMENTS', 'chat');
                                    _this.isLoading = false;
                                    _this.isLoadingMore = false;
                                    return;
                                }
                                (_a = _this.comments).unshift.apply(_a, tslib_1.__spread(comments));
                                _this.isLoading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TabCommentsComponent.prototype.scrollToBottom = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, delay(10)];
                    case 1:
                        _a.sent();
                        this.commentBody.nativeElement.scrollTo({
                            top: this.commentBody.nativeElement.scrollHeight,
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    TabCommentsComponent.prototype.onScroll = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.isLoadingMore = true;
                this.offset += this.limit;
                this.getComments();
                return [2 /*return*/];
            });
        });
    };
    TabCommentsComponent.prototype.onKeydownEvent = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.commentForm.invalid) {
                            return [2 /*return*/];
                        }
                        if (this.isLoading) {
                            return [2 /*return*/];
                        }
                        if (event.key !== 'Enter') {
                            return [2 /*return*/];
                        }
                        if (event.ctrlKey) {
                            this.messageFormControl.setValue(this.messageFormControl.value + "\n");
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.addComment()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TabCommentsComponent.prototype.isMe = function (comment) {
        return comment.postedBy.id === this.currentUser.id;
    };
    TabCommentsComponent.prototype.removeComment = function (comment) {
        this.maintenancesApi.removeMaintenanceComment(comment.id).subscribe();
        comment.archived = true;
    };
    TabCommentsComponent.prototype.addComment = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var message, comment;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.commentForm.invalid) {
                            return [2 /*return*/];
                        }
                        this.messageFormControl.disable();
                        message = {
                            message: this.messageFormControl.value.trim(),
                            type: this.commentForm.value.type.trim(),
                            maintenanceId: this.maintenance.id,
                        };
                        this.commentForm.controls.message.setValue('');
                        return [4 /*yield*/, this.maintenancesApi.createMaintenanceComment(message)];
                    case 1:
                        comment = _a.sent();
                        if (comment) {
                            this.comments.push(comment);
                        }
                        return [4 /*yield*/, this.scrollToBottom()];
                    case 2:
                        _a.sent();
                        this.messageFormControl.enable();
                        this.messageFormControl.setValue(this.messageFormControl.value.trim());
                        this.commentTextArea.nativeElement.focus();
                        return [2 /*return*/];
                }
            });
        });
    };
    TabCommentsComponent.prototype.getPostedByName = function (comment) {
        if (comment.postedBy.type === 'company' && comment.company) {
            return comment.postedBy.name + " - " + comment.company.name;
        }
        return comment.postedBy.name + " - " + this.account.name;
    };
    return TabCommentsComponent;
}());
export { TabCommentsComponent };
export { ɵ0 };
